// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"Tooltip_tooltipWrapper__Ba+31","tooltipBox":"Tooltip_tooltipBox__V3NPe","visible":"Tooltip_visible__xUk3C"};